export default class Mapping {
  constructor(browser, ad) {
    this.browser = browser;
    this.ad = ad;
  }
}
